import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../services/authenticationService';
import { Routes } from '../utility/constants';


@Component({
    selector: 'app-public',
    templateUrl: './default.component.html'
})

export class DefaultComponent {
    constructor( private auth: AuthenticationService, public router: Router) { }
    logOut() {
        this.auth.logout();
        this.router.navigate([Routes.Login]);
    }
}
